export const readStoredJson = (key, fallback) => {
  try {
    if (typeof localStorage === "undefined") return fallback;

    const saved = localStorage.getItem(key);
    return saved ? JSON.parse(saved) : fallback;
  } catch {
    return fallback;
  }
};

export const writeStoredJson = (key, value) => {
  try {
    if (typeof localStorage === "undefined") return;

    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.warn(`Unable to persist ${key}`, error);
  }
};
